import { ChainId } from '@/features/crosschain-buy/domain/flow'
import type { SourceChainOption } from '@/features/crosschain-buy/source-tokens'

interface ChainSelectionDeps {
  selectedChainId: () => number
  applyEdit: (edit: () => void | Promise<void>) => Promise<boolean>
  selectSourceChain: (chainId: number) => void
  invalidateRouteContext: () => void
  activateSolana: () => Promise<void>
}

export const createChainSelectionHandler = (deps: ChainSelectionDeps) => {
  let selectionIntent = 0
  return async (chain: SourceChainOption): Promise<void> => {
    if (chain.chainId === deps.selectedChainId()) return
    const intent = ++selectionIntent
    await deps.applyEdit(async () => {
      if (intent !== selectionIntent) return
      deps.selectSourceChain(chain.chainId)
      deps.invalidateRouteContext()
      if (chain.chainId === ChainId.SOLANA) {
        await deps.activateSolana().catch(() => undefined)
      }
    })
  }
}
